module.exports = "<%= icon %><span class=\"sharecount__value sharecount__value--short\">0</span> Shares\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/content/share-count-immersive.html
// module id = 712
// module chunks = 2